import * as perimeterx from "./perimeterx";
import { getAnalyticsHost, getClient, getBusinessType, getDeviceType, getPublishPath, getSVOCID, isConsumerApp, isNucleus, isOverlay, isProdDeployment, isUserPersisted, stringAppendWithDelimiter } from "./utilities";

import { createInstance } from "@adobe/alloy";

( function () {
	
	// An indicator for build_local mappings 
	console.log( '%c' + LOG_PREFIX + ' -- Local Build Mapping: ' + CODE_VERSION + ' | ' + BUILD_TARGET + ' | 2025-07-23T14:23:38.656Z', 'background: orange; color: white; display: block; line-height:20px; padding:5px 30px; border: 1px solid red; font-size:1em;' );

	window._T = ( window._T ? _T : {} ); // Leave in for Legacy Support
	_T.pageData = ( Array.isArray( _T.pageData ) ? _T.pageData : [] ); 

	window._aape = {};
	window._aape.diagnostics = {};
	window._aape.deployments = {};
	window._aape.pageState = "";
	window._aape.beaconFired = false;

    window.digitalData = ( window.digitalData ? digitalData : { event: [] } );

	window._aape.featureSwitches = {
		diagnosticsEnabled: false
	}
	window._aape.diagnosticsBeaconFired = false;




	// Prehiding Style for Alloy Target Asynchronous Implementation
	// https://experienceleague.adobe.com/en/docs/platform-learn/implement-web-sdk/applications-setup/setup-target#add-flicker-handling
	!function( e, a, n, t ) {
		var i = e.head; if ( i ) {
			if ( a ) return;
			var o = e.createElement( "style" );
			o.id = "alloy-prehiding", o.innerText = n, i.appendChild( o ), setTimeout( function() { o.parentNode && o.parentNode.removeChild( o ) }, t )
		}
	} ( document, document.location.href.indexOf( "adobe_authoring_enabled" ) !== -1, ".personalization-container { opacity: 0 !important }", 2000 );

	// Monitor for Alloy
	// let monitors = {
	// 	onInstanceCreated( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onInstanceCreated] ", data );
	// 		// data.instanceName
	// 		// data.instance
	// 	},
	// 	onInstanceConfigured( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onInstanceConfigured] ", data );
	// 		// data.instanceName
	// 		// data.config
	// 	},
	// 	onBeforeCommand( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onBeforeCommand] ", data );
	// 		// data.instanceName
	// 		// data.commandName
	// 		// data.options
	// 	},
	// 	// Added in version 2.4.0
	// 	onCommandResolved( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onCommandResolved] ", data );
	// 		// data.instanceName
	// 		// data.commandName
	// 		// data.options
	// 		// data.result
	// 	},
	// 	// Added in version 2.4.0
	// 	onCommandRejected( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onCommandRejected] ", data );
	// 		// data.instanceName
	// 		// data.commandName
	// 		// data.options
	// 		// data.error
	// 	},
	// 	onBeforeNetworkRequest( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onBeforeNetworkRequest] ", data );
	// 		// data.instanceName
	// 		// data.requestId
	// 		// data.url
	// 		// data.payload
	// 	},
	// 	onNetworkResponse( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onNetworkResponse] ", data );
	// 		// data.instanceName
	// 		// data.requestId
	// 		// data.url
	// 		// data.payload
	// 		// data.body
	// 		// data.parsedBody
	// 		// data.status
	// 		// data.retriesAttempted
	// 	},
	// 	onNetworkError( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onNetworkError] ", data );
	// 		// data.instanceName
	// 		// data.requestId
	// 		// data.url
	// 		// data.payload
	// 		// data.error
	// 	},
	// 	onBeforeLog( data ) {
	// 		console.log( LOG_PREFIX + " -- Alloy Monitors [onBeforeLog] ", data );
	// 		// data.instanceName
	// 		// data.componentName
	// 		// data.level
	// 		// data.arguments
	// 	}
	// };

	// window.alloy = createInstance( { name: "alloy", monitors: [ monitors ] } );

	const datastreamId = location.hostname.indexOf( 'homedepot.com' ) >= 1 ? "dc11b07a-3ab0-4e77-bee8-3eb5a1c9a0b8" : "4c9f3c74-6f5d-472b-9dbe-d7b146d9fd2b";

	window.alloy = createInstance( { name: "alloy" } );

	// Collect context information using the Web SDK JavaScript library
	// If you omit the context array when configuring the SDK, all context information except "highEntropyUserAgentHints" is collected by default.

	alloy( "configure", {
		"edgeDomain": "swasc.homedepot.com",
		"datastreamId": datastreamId,
		"orgId": "F6421253512D2C100A490D45@AdobeOrg",
		"downloadLinkQualifier": "\\.(exe|zip|wav|mp3|mov|mpg|avi|wmv|pdf|doc|docx|xls|xlsx|ppt|pptx)$",
		"debugEnabled": false,
		"idMigrationEnabled": true, // https://experienceleague.adobe.com/en/docs/experience-platform/web-sdk/identity/overview
		"prehidingStyle": "body { opacity: 0 !important }",
		"clickCollectionEnabled": true,
		"clickCollection": {
			"internalLinkEnabled": true,
			"downloadLinkEnabled": true,
			"externalLinkEnabled": true,
			"sessionStorageEnabled": true,
			"eventGroupingEnabled": true,
			filterClickDetails: ( clickData ) => {

				// console.log( LOG_PREFIX + " -- [filterClickDetails] ", clickData );

				let excludeURLs = [
					'/account/view/instantcheckout',
					'/account/view/paymentcards',
					'/auth/view/checkout/signin',
					'/auth/view/forgotpassword',
					'/auth/view/signin',
					'/mycart/home',
					'/mycheckout/checkout',
					'/mycheckout/toolrental'
				];

				//if path is in exceptions then return false so that event processing is stopped, without an error, and the event is not sent.
				if ( excludeURLs.includes( window.location.pathname ) ) {
					// console.log( LOG_PREFIX + " -- filterClickDetails -- excluded URL: ", window.location.pathname );
					return false;
				}

				function _findClickID( el ) {

					if ( !el || typeof ( el.getAttribute ) !== 'function' ) return null;

					let found = el.getAttribute( "clickid" );

					if ( found ) return found;
					if ( el.parentNode ) return _findClickID( el.parentNode );

					return null;
				}

				let cid = _findClickID( clickData.clickedElement );

				if ( cid ) {
					clickData.linkRegion = cid;
				}

				// console.log( LOG_PREFIX + " -- filterClickDetails -- linkRegion: ", clickData.linkRegion );

			}
		}
	} );

	const perimeterXEnabled = ( !( window._pxAppId ) && !isOverlay() );
	perimeterXEnabled && perimeterx.init()
		.then( () => {
			// console.log( LOG_PREFIX + " -- PX Init Worked"  );
		} ).catch( ( error ) => {
			console.log( LOG_PREFIX + " -- PX Init Failed: ", error );
		} );

	// ECID is needed in Core and also by 3P.
	window.alloy( "getIdentity" )
		.then( function( result ) {

			// console.log( LOG_PREFIX + " getIdentity result: ", result );

			_aape.ECID = result.identity.ECID

			perimeterx.setPXParam2( _aape.ECID );

		} )
		.catch( function( error ) {

			// The command failed.
			// "error" will be an error object with additional information.
			console.log( LOG_PREFIX + " getIdentity Error: ", error );

		} );

	_aape.scriptHost = getAnalyticsHost( document.currentScript?.src );
	_aape.deviceType = getDeviceType();
	_aape.siteBusinessType = getBusinessType();

	//Grab SVOCID here for easy use throughout Request lifecycle 
	_aape.svocid = getSVOCID();
	_aape.isUserPersisted = isUserPersisted();

	if ( !isNucleus() ) {

		let h = document.getElementsByTagName( "script" )[ 0 ],
			s = document.createElement( "script" );
		s.async = 1;
		s.src = "//assets.thdstatic.com/target/" + getPublishPath() + "/current/target.js";
		h.insertBefore( s, h.firstChild );

	}

	alloy( "getLibraryInfo" )
		.then( function( result ) {

			_aape.alloyLibraryInfo = result.libraryInfo

			window._aape.deployments.sync = {
				build: BUILD_TARGET,
				version: CODE_VERSION,
				ts: '2025-07-23T14:23:38.656Z',
				host: _aape.scriptHost,
				alloy: _aape.alloyLibraryInfo.version
			};

		} )
		.catch( function( error ) {
			// The command failed.
			// "error" will be an error object with additional information.
			console.log( LOG_PREFIX + " getIdentity Error: ", error );
		} );

	const getReportSuiteOverrides = function( businessType = "" ) {

		let isMilitaryExchange = ( location.hostname.indexOf( 'exchange.homedepot.com' ) !== -1 || location.hostname.indexOf( 'storefront.homedepot.com' ) !== -1 ? true : false ),
			suitesSet = new Set();

		if ( isProdDeployment() ) {

			suitesSet.add( "homedepotglobalproduction" );

			if ( businessType.toString().toLowerCase() === "b2b" ) {
				suitesSet.add( "homedepotb2bprod" );
			}

			if ( isMilitaryExchange ) {
				suitesSet.add( "homedepotmilitary" );
			}

		}
		else {

			suitesSet.add( "homewebsdkpocdev" );
			suitesSet.add( "homedepotglobaldev" );

			if ( businessType.toString().toLowerCase() === "b2b" ) {
				suitesSet.add( "homedepotb2bdev" );
			}

		}

		let uniqueSuites = Array.from( new Set( suitesSet ) );

		// We want to remove the B2B report suites for Native Apss for now
		// TODO: follow up on if/when this will change
		if ( isConsumerApp() ) {

			let indexOfRSID = uniqueSuites.indexOf( 'homedepotb2bprod' );
			indexOfRSID = indexOfRSID > -1 ? indexOfRSID : uniqueSuites.indexOf( 'homedepotb2bdev' );

			if ( indexOfRSID > -1 ) {
				uniqueSuites.splice( indexOfRSID, 1 );
			}

		}

		return uniqueSuites;

	};

	const sendDiagnosticBeacon = ( condition = "" ) => {

		if ( _aape.beaconFired || _aape.diagnosticsBeaconFired ) return;

		_aape.diagnosticsBeaconFired = true;

		let getUUID = () => {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace( /[xy]/g, function( c ) {
				var r = Math.random() * 16 | 0,
					v = c === 'x' ? r : ( r & 0x3 | 0x8 );
				return v.toString( 16 );
			} );
		}

		let xdmData = {
			"_experience": {
				"analytics": {
					"customDimensions": {
						"props": {
							"prop55": "diagnositc" + ( condition ? " | condition: " + condition : "" ),
							"prop68": _aape.pageState
						},
						"eVars": {
							"eVar25": ( function() {

								var btstrap = getClient();

								if ( isConsumerApp() ) {
									return 'consumer app';
								}
								else if ( btstrap === 'homedepot' ) {
									return 'desktop';
								}
								else if ( btstrap === 'homedepotmobile' ) {
									return 'mobile';
								}
								else {
									return btstrap;
								}
							}() ),
							"eVar60": ( function() {
								if ( window.QuantumMetricAPI ) {
									let getUser = ( typeof ( window.QuantumMetricAPI.getUserID ) === 'function' ? window.QuantumMetricAPI.getUserID() : undefined ),
										getSession = ( typeof ( window.QuantumMetricAPI.getSessionID ) === 'function' ? window.QuantumMetricAPI.getSessionID() : undefined );
									return ( typeof ( getUser ) === 'string' ? getUser : 'na' ) + '|' + ( typeof ( getSession ) === 'string' ? getSession : 'na' );
								}
							}() ),
							"eVar92": _aape.pxbs,
							"eVar99": _aape.ECID
						},
					}
				}
			},
			"web": {
				"webPageDetails": {
					"name": document.title,
					"URL": document.URL,
				},
				"webReferrer": {
					"URL": document.referrer ?? ""
				}
			},
		};

		// Optional: If you’d like, you can also generate a UUID for the _id field and a timestamp manually for inclusion in the `data` object. 
		xdmData._id = getUUID();
		xdmData._timestamp = new Date();

		xdmData.web.webInteraction = {
			"linkClicks": {
				"value": 1
			},
			"name": `Diagnostics Beacon | Path - ${ _aape.diagnosticPagePathState_Core }`, // Name that shows up in the custom links report
			"URL": document.URL, // The URL of the link
			"type": "other" // values: other, download, exit

		}

		window.alloy( "sendEvent", {
			"documentUnloading": true,
			"xdm": xdmData,
			edgeConfigOverrides: {
				com_adobe_analytics: {
					reportSuites: getReportSuiteOverrides( digitalData?.site?.businessType )
				}
			}
		} ).catch( function( error ) {
			// The command failed.
			console.log( LOG_PREFIX + " -- ALLOY sendEvent ERROR: ", error );
		} );

		console.log( LOG_PREFIX + " -- Diagnostics Beacon Fired" );

	}

	const setupDiagnosticsBeacon = () => { 
		
		setTimeout( () => {
	
			sendDiagnosticBeacon( "time limit reached" );

		}, 25000 );

		// Add unload event listener
		window.addEventListener( 'unload', function() {

			sendDiagnosticBeacon( "unload" );

		} );

	}

	if ( _aape.featureSwitches.diagnosticsEnabled ) {

		if ( document.prerendering ) {

			_aape.pageState = stringAppendWithDelimiter( _aape.pageState, "prerendering", ">" );

			document.addEventListener(
				'prerenderingchange',
				function() {

					console.log( LOG_PREFIX + " -- window.preRenderState: ", window.preRenderState );
					console.log( LOG_PREFIX + " -- document.prerendering: ", document.prerendering );

					setupDiagnosticsBeacon();

					_aape.pageState = stringAppendWithDelimiter( _aape.pageState, "activated | time to activation: " + self.performance?.getEntriesByType?.( 'navigation' )[ 0 ]?.activationStart, ">" );

				},
				{ once: true } );
		}
		else {

			setupDiagnosticsBeacon();

			console.log( LOG_PREFIX + " -- document.readyState: ", document.readyState );

			if ( !self.performance?.getEntriesByType?.( 'navigation' )[ 0 ]?.activationStart ) {

				_aape.pageState = stringAppendWithDelimiter( _aape.pageState, "no prerender", ">" );

			} else {

				_aape.pageState = stringAppendWithDelimiter( _aape.pageState, "prerendered and activated", ">" );

			}

		}

	} else {
		console.log( LOG_PREFIX + " -- Diagnostics Beacon is disabled" );
	}

} )();
